import service from '@/utils/request';



// 第一步：生成动画或者游戏时的规则确认页
export function ruleJudge (data) {
  return service({
    url: '/v1/animation/ruleJudge',
    method: 'POST',
    data: data
  })
}

//第二步：确定好规则提交生成对应文本
export function getRuleInformation (data) {
  return service({
    url: '/v1/animation/getRuleInformation',
    method: 'POST',
    data: data
  })
}


// 第三步：定时调用获取html地址
export function getHtmlUrl (data) {
  return service({
    url: '/v1/animation/getHtmlUrl',
    method: 'POST',
    data: data
  })
}


// 动画或者游戏公开发布 返回发布后的资源ID 0表示发布失败
export function publicReleaseAni (data) {
  return service({
    url: '/v1/animation/publicRelease',
    method: 'get',
    params: data
  })
}

// 获取标签选项列表
export function getTagOptionsAni (data) {
  return service({
    url: '/v1/animation/getTagOptions',
    method: 'get',
    params: data
  })
}



// 下载HtmlUrl
export function downloadHtmlUrl (data) {
  return service({
    url: '/v1/animation/downloadHtmlUrl',
    method: 'get',
    params: data
  })
}